import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import GeneralDisclosure21 from "./GeneralDisclosure/GeneralDisclosure21";
import GeneralDisclosure22 from "./GeneralDisclosure/GeneralDisclosure22";
import GeneralDisclosure23 from "./GeneralDisclosure/GeneralDisclosure23";
import GeneralDisclosure24 from "./GeneralDisclosure/GeneralDisclosure24";
import GeneralDisclosure25 from "./GeneralDisclosure/GeneralDisclosure25";
import GeneralDisclosure26 from "./GeneralDisclosure/GeneralDisclosure26";
import GeneralDisclosure27 from "./GeneralDisclosure/GeneralDisclosure27";
import GeneralDisclosure28 from "./GeneralDisclosure/GeneralDisclosure28";
import GeneralDisclosure29 from "./GeneralDisclosure/GeneralDisclosure29";
import GeneralDisclosure210 from "./GeneralDisclosure/GeneralDisclosure210";
import GeneralDisclosure211 from "./GeneralDisclosure/GeneralDisclosure211";
import GeneralDisclosure212 from "./GeneralDisclosure/GeneralDisclosure212";
import GeneralDisclosure213 from "./GeneralDisclosure/GeneralDisclosure213";
import GeneralDisclosure214 from "./GeneralDisclosure/GeneralDisclosure214";
import GeneralDisclosure215 from "./GeneralDisclosure/GeneralDisclosure215";
import GeneralDisclosure216 from "./GeneralDisclosure/GeneralDisclosure216";
import GeneralDisclosure217 from "./GeneralDisclosure/GeneralDisclosure217";
import GeneralDisclosure218 from "./GeneralDisclosure/GeneralDisclosure218";
import GeneralDisclosure219 from "./GeneralDisclosure/GeneralDisclosure219";
import GeneralDisclosure220 from "./GeneralDisclosure/GeneralDisclosure220";
import GeneralDisclosure221 from "./GeneralDisclosure/GeneralDisclosure221";
import GeneralDisclosure222 from "./GeneralDisclosure/GeneralDisclosure222";
import GeneralDisclosure223 from "./GeneralDisclosure/GeneralDisclosure223";
import GeneralDisclosure224 from "./GeneralDisclosure/GeneralDisclosure224";
import GeneralDisclosure225 from "./GeneralDisclosure/GeneralDisclosure225";
import GeneralDisclosure226 from "./GeneralDisclosure/GeneralDisclosure226";
import GeneralDisclosure227 from "./GeneralDisclosure/GeneralDisclosure227";
import GeneralDisclosure228 from "./GeneralDisclosure/GeneralDisclosure228";
import GeneralDisclosure229 from "./GeneralDisclosure/GeneralDisclosure229";
import GeneralDisclosure230 from "./GeneralDisclosure/GeneralDisclosure230";
import GRI201_1 from "./EconomicPerformance/GRI201/GRI201-1";
import GRI201_2 from "./EconomicPerformance/GRI201/GRI201-2";
import GRI201_3 from "./EconomicPerformance/GRI201/GRI201-3";
import GRI201_4 from "./EconomicPerformance/GRI201/GRI201-4";
import GRI202_1 from "./EconomicPerformance/GRI202/GRI202-1";
import GRI202_2 from "./EconomicPerformance/GRI202/GRI202-2";
import GRI203_1 from "./EconomicPerformance/GRI203/GRI203-1";
import GRI203_2 from "./EconomicPerformance/GRI203/GRI203-2";
import GRI204_1 from "./EconomicPerformance/GRI204/GRI204-1";
import GRI205_3 from "./EconomicPerformance/GRI205/GRI205-3";
import GRI205_2 from "./EconomicPerformance/GRI205/GRI205-2";
import GRI205_1 from "./EconomicPerformance/GRI205/GRI205-1";
import GRI206_1 from "./EconomicPerformance/GRI206/GRI206-1";
import GRI207_1 from "./EconomicPerformance/GRI207/GRI207-1";
import GRI207_2 from "./EconomicPerformance/GRI207/GRI207-2";
import GRI207_3 from "./EconomicPerformance/GRI207/GRI207-3";
import GRI207_4 from "./EconomicPerformance/GRI207/GRI207-4";
import GRI301_1 from "./GRI300/GRI301/GRI301-1";
import GRI301_2 from "./GRI300/GRI301/GRI301-2";
import GRI301_3 from "./GRI300/GRI301/GRI301-3";
import GRI302_1 from "./GRI300/GRI302/GRI302-1";
import GRI302_2 from "./GRI300/GRI302/GRI302-2";
import GRI302_3 from "./GRI300/GRI302/GRI302-3";
import GRI302_4 from "./GRI300/GRI302/GRI302-4";
import GRI302_5 from "./GRI300/GRI302/GRI302-5";
import GRI303_1 from "./GRI300/GRI303/GRI303-1";
import GRI303_2 from "./GRI300/GRI303/GRI303-2";
import GRI303_3 from "./GRI300/GRI303/GRI303-3";
import GRI303_4 from "./GRI300/GRI303/GRI303-4";
import GRI303_5 from "./GRI300/GRI303/GRI303-5";
import GRI304_1 from "./GRI300/GRI304/GRI304-1";
import GRI304_2 from "./GRI300/GRI304/GRI304-2";
import GRI304_3 from "./GRI300/GRI304/GRI304-3";
import GRI304_4 from "./GRI300/GRI304/GRI304-4";
import GRI305_6 from "./GRI300/GRI305/GRI305-6";
import GRI305_7 from "./GRI300/GRI305/GRI305-7";
import GRI305_5 from "./GRI300/GRI305/GRI305-5";
import GRI305_1 from "./GRI300/GRI305/GRI305-1";
import GRI305_2 from "./GRI300/GRI305/GRI305-2";
import GRI305_3 from "./GRI300/GRI305/GRI305-3";
import GRI305_4 from "./GRI300/GRI305/GRI305-4";
import GRI306_1 from "./GRI300/GRI306/GRI306-1";
import GRI306_2 from "./GRI300/GRI306/GRI306-2";
import GRI306_3 from "./GRI300/GRI306/GRI306-3";
import GRI306_4 from "./GRI300/GRI306/GRI306-4";
import GRI306_5 from "./GRI300/GRI306/GRI306-5";
import GRI308_1 from "./GRI300/GRI308/GRI308-1";
import GRI308_2 from "./GRI300/GRI308/GRI308-2";
import GRI403_8 from "./GRI400/GRI403/GRI403-8";
import GRI403_9 from "./GRI400/GRI403/GRI403-9";
import GRI403_10 from "./GRI400/GRI403/GRI403-10";
import GRI401_1 from "./GRI400/GRI401/GRI401-1";
import GRI401_2 from "./GRI400/GRI401/GRI401-2";
import GRI401_3 from "./GRI400/GRI401/GRI401-3";
import GRI402 from "./GRI400/GRI402";
import GRI403_1 from "./GRI400/GRI403/GRI403-1";
import GRI403_2 from "./GRI400/GRI403/GRI403-2";
import GRI403_3 from "./GRI400/GRI403/GRI403-3";
import GRI403_4 from "./GRI400/GRI403/GRI403-4";
import GRI403_5 from "./GRI400/GRI403/GRI403-5";
import GRI403_6 from "./GRI400/GRI403/GRI403-6";
import GRI403_7 from "./GRI400/GRI403/GRI403-7";
import GRI404_1 from "./GRI400/GRI404/GRI404-1";
import GRI404_2 from "./GRI400/GRI404/GRI404-2";
import GRI404_3 from "./GRI400/GRI404/GRI404-3";
import GRI405_1 from "./GRI400/GRI405/GRI405-1";
import GRI405_2 from "./GRI400/GRI405/GRI405-2";
import GRI406 from "./GRI400/GRI406";
import GRI407 from "./GRI400/GRI407";
import GRI408 from "./GRI400/GRI408";
import GRI409 from "./GRI400/GRI409";
import GRI410 from "./GRI400/GRI410";
import GRI411 from "./GRI400/GRI411";
import GRI415 from "./GRI400/GRI415";
import GRI418 from "./GRI400/GRI418";
import GRI413_1 from "./GRI400/GRI413/GRI413-1";
import GRI413_2 from "./GRI400/GRI413/GRI413-2";
import GRI414_1 from "./GRI400/GRI414/GRI414-1";
import GRI414_2 from "./GRI400/GRI414/GRI414-2";
import GRI416_1 from "./GRI400/GRI416/GRI416-1";
import GRI416_2 from "./GRI400/GRI416/GRI416-2";
import GRI417_1 from "./GRI400/GRI417/GRI417-1";
import GRI417_2 from "./GRI400/GRI417/GRI417-2";
import GRI417_3 from "./GRI400/GRI417/GRI417-3";
import styles from "../../styles/gri/general.module.css";
import { useParams } from "react-router-dom";
import { get } from "../../utils/api";

// Helper to check if any page in a group is selected
const isAnySelected = (pages) => Object.values(pages || {}).some(Boolean);

// Page break component
const PageBreak = () => <div className="page-break" />;

// The main component for Puppeteer download
const GRIDownloadPuppeteer = () => {
  const pdfRef = useRef();
  // // selectedPages should be passed as a prop or set on window.selectedPages for Puppeteer
  // if (!selectedPages && typeof window !== "undefined") {
  //   selectedPages = window.selectedPages;
  // }
  // if (!selectedPages) return null;
  const { id } = useParams();

  console.log("firstid", id);

  const [selectedPages, setSelectedPages] = useState({
    generalDisclosure: {
      all: false,
      pages: {
        general21: false,
        general22: false,
        general23: false,
        general24: false,
        general25: false,
        general26: false,
        general27: false,
        general28: false,
        general29: false,
        general210: false,
        general211: false,
        general212: false,
        general213: false,
        general214: false,
        general215: false,
        general216: false,
        general217: false,
        general218: false,
        general219: false,
        general220: false,
        general221: false,
        general222: false,
        general223: false,
        general224: false,
        general225: false,

        general226: false,
        general227: false,
        general228: false,
        general229: false,
        general230: false,
      },
    },
    series200: {
      all: false,
      pages: {
        gri201: {
          all: false,
          pages: {
            gri201_1: false,
            gri201_2: false,
            gri201_3: false,
            gri201_4: false,
          },
        },
        gri202: {
          all: false,
          pages: {
            gri202_1: false,
            gri202_2: false,
          },
        },
        gri203: {
          all: false,
          pages: {
            gri203_1: false,
            gri203_2: false,
          },
        },

        gri204: {
          all: false,
          pages: {
            gri204_1: false,
          },
        },
        gri205: {
          all: false,
          pages: {
            gri205_1: false,
            gri205_2: false,
            gri205_3: false,
          },
        },

        gri206: {
          all: false,
          pages: {
            gri206_1: false,
          },
        },
        gri207: {
          all: false,
          pages: {
            gri207_1: false,
            gri207_2: false,
            gri207_3: false,
            gri207_4: false,
          },
        },
      },
    },
    series300: {
      all: false,
      pages: {
        gri301: {
          all: false,
          pages: {
            gri301_1: false,
            gri301_2: false,
            gri301_3: false,
          },
        },
        gri302: {
          all: false,
          pages: {
            gri302_1: false,
            gri302_2: false,
            gri302_3: false,
            gri302_4: false,
            gri302_5: false,
          },
        },
        gri303: {
          all: false,
          pages: {
            gri303_1: false,
            gri303_2: false,
            gri303_3: false,
            gri303_4: false,
            gri303_5: false,
          },
        },
        gri304: {
          all: false,
          pages: {
            gri304_1: false,
            gri304_2: false,
            gri304_3: false,
            gri304_4: false,
          },
        },
        gri305: {
          all: false,
          pages: {
            gri305_1: false,
            gri305_2: false,
            gri305_3: false,
            gri305_4: false,
            gri305_5: false,
            gri305_6: false,
            gri305_7: false,
          },
        },
        gri306: {
          all: false,
          pages: {
            gri306_1: false,
            gri306_2: false,
            gri306_3: false,
            gri306_4: false,
            gri306_5: false,
          },
        },
        gri308: {
          all: false,
          pages: {
            gri308_1: false,
            gri308_2: false,
          },
        },
      },
    },
    series400: {
      all: false,
      pages: {
        gri401: {
          all: false,
          pages: {
            gri401_1: false,
            gri401_2: false,
            gri401_3: false,
          },
        },
        gri402: {
          all: false,
          pages: {
            gri402: false,
          },
        },
        gri403: {
          all: false,
          pages: {
            gri403_1: false,
            gri403_2: false,
            gri403_3: false,
            gri403_4: false,
            gri403_5: false,
            gri403_6: false,
            gri403_7: false,
            gri403_8: false,
            gri403_9: false,
            gri403_10: false,
          },
        },
        gri404: {
          all: false,
          pages: {
            gri404_1: false,
            gri404_2: false,
            gri404_3: false,
          },
        },
        gri405: {
          all: false,
          pages: {
            gri405_1: false,
            gri405_2: false,
          },
        },
        gri413: {
          all: false,
          pages: {
            gri413_1: false,
            gri413_2: false,
          },
        },
        gri414: {
          all: false,
          pages: {
            gri414_1: false,
            gri414_2: false,
          },
        },
        gri416: {
          all: false,
          pages: {
            gri416_1: false,
            gri416_2: false,
          },
        },
        gri417: {
          all: false,
          pages: {
            gri417_1: false,
            gri417_2: false,
            gri417_3: false,
          },
        },
        // gri406: false,
        // gri407: false,
        // gri408: false,
        // gri409: false,
        // gri410: false,
        // gri411: false,
        // gri415: false,
        // gri418: false,
        gri406: {
          all: false,
          pages: {
            gri406: false,
          },
        },
        gri407: {
          all: false,
          pages: {
            gri407: false,
          },
        },
        gri408: {
          all: false,
          pages: {
            gri408: false,
          },
        },
        gri409: {
          all: false,
          pages: {
            gri409: false,
          },
        },
        gri410: {
          all: false,
          pages: {
            gri410: false,
          },
        },
        gri411: {
          all: false,
          pages: {
            gri411: false,
          },
        },
        gri415: {
          all: false,
          pages: {
            gri415: false,
          },
        },
        gri418: {
          all: false,
          pages: {
            gri418: false,
          },
        },
      },
    },
  });

  const fetchData = async () => {
    try {
      let resp = await get(`/gri/preview?id=${id}`);
      if (resp?.data?.data?.selectedPages) {
        setSelectedPages(resp?.data?.data?.selectedPages[0]);
      } else {
        console.error("No selectedPages data found in response:", resp);
      }
    } catch (error) {
      console.error("Error fetching selected pages:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  console.log("firsts", selectedPages);

  return (
    <>
      <style>
        {`
          html, body {
            height: auto !important;
            min-height: 100vh !important;
            overflow: visible !important;
          }
          #root {
            height: auto !important;
            min-height: 100vh !important;
            overflow: visible !important;
          }
          .page-break {
            page-break-before: always;
          }
          .page-break + * {
            margin-top: 0 !important;
            padding-top: 0 !important;
          }
        `}
      </style>
      <div
        style={{
          width: "100%",
          minHeight: "100vh",
          height: "auto",
          overflow: "visible",
          position: "relative",
          backgroundColor: "#fff",
          // Debug styles to see the full content
          padding: "0px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
            // pb: "1rem",
            minHeight: "100vh",
            height: "auto",
            overflow: "visible",
            position: "relative",
            // flex: "1 1 auto",
          }}
          ref={pdfRef}
        >
          {/* General Disclosure Sections */}
          {selectedPages.generalDisclosure?.pages?.general21 && (
            <>
              <PageBreak />
              <GeneralDisclosure21 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general22 && (
            <>
              <PageBreak />
              <GeneralDisclosure22 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general23 && (
            <>
              <PageBreak />
              <GeneralDisclosure23 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general24 && (
            <>
              <PageBreak />
              <GeneralDisclosure24 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general25 && (
            <>
              <PageBreak />
              <GeneralDisclosure25 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general26 && (
            <>
              <PageBreak />
              <GeneralDisclosure26 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general27 && (
            <>
              <PageBreak />
              <GeneralDisclosure27 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general28 && (
            <>
              <PageBreak />
              <GeneralDisclosure28 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general29 && (
            <>
              <PageBreak />
              <GeneralDisclosure29 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general210 && (
            <>
              <PageBreak />
              <GeneralDisclosure210 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general211 && (
            <>
              <PageBreak />
              <GeneralDisclosure211 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general212 && (
            <>
              <PageBreak />
              <GeneralDisclosure212 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general213 && (
            <>
              <PageBreak />
              <GeneralDisclosure213 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general214 && (
            <>
              <PageBreak />
              <GeneralDisclosure214 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general215 && (
            <>
              <PageBreak />
              <GeneralDisclosure215 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general216 && (
            <>
              <PageBreak />
              <GeneralDisclosure216 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general217 && (
            <>
              <PageBreak />
              <GeneralDisclosure217 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general218 && (
            <>
              <PageBreak />
              <GeneralDisclosure218 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general219 && (
            <>
              <PageBreak />
              <GeneralDisclosure219 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general220 && (
            <>
              <PageBreak />
              <GeneralDisclosure220 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general221 && (
            <>
              <PageBreak />
              <GeneralDisclosure221 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general222 && (
            <>
              <PageBreak />
              <GeneralDisclosure222 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general223 && (
            <>
              <PageBreak />
              <GeneralDisclosure223 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general224 && (
            <>
              <PageBreak />
              <GeneralDisclosure224 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general225 && (
            <>
              <PageBreak />
              <GeneralDisclosure225 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general226 && (
            <>
              <PageBreak />
              <GeneralDisclosure226 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general227 && (
            <>
              <PageBreak />
              <GeneralDisclosure227 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general228 && (
            <>
              <PageBreak />
              <GeneralDisclosure228 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general229 && (
            <>
              <PageBreak />
              <GeneralDisclosure229 hide={true} downloadMode={true} />
            </>
          )}
          {selectedPages.generalDisclosure?.pages?.general230 && (
            <>
              <PageBreak />
              <GeneralDisclosure230 hide={true} downloadMode={true} />
            </>
          )}
          {/* 200 Series Sections */}
          {isAnySelected(selectedPages.series200?.pages?.gri201?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                201 : Economic Performance
              </p>
              {selectedPages.series200.pages.gri201.pages.gri201_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI201_1 hide={true} downloadMode={true} />
                </>
              )}
              {selectedPages.series200.pages.gri201.pages.gri201_2 && (
                <>
                  <PageBreak />
                  <GRI201_2 hide={true} />
                </>
              )}
              {selectedPages.series200.pages.gri201.pages.gri201_3 && (
                <>
                  <PageBreak />
                  <GRI201_3 hide={true} />
                </>
              )}
              {selectedPages.series200.pages.gri201.pages.gri201_4 && (
                <>
                  <PageBreak />
                  <GRI201_4 hide={true} downloadMode={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series200?.pages?.gri202?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                202 : Market Presence 2016
              </p>
              {selectedPages.series200.pages.gri202.pages.gri202_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI202_1 hide={true} />
                </>
              )}
              {selectedPages.series200.pages.gri202.pages.gri202_2 && (
                <>
                  <PageBreak />
                  <GRI202_2 hide={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series200?.pages?.gri203?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                203 : Indirect Economic Impact
              </p>
              {selectedPages.series200.pages.gri203.pages.gri203_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI203_1 hide={true} downloadMode={true} />
                </>
              )}
              {selectedPages.series200.pages.gri203.pages.gri203_2 && (
                <>
                  <PageBreak />
                  <GRI203_2 hide={true} />
                </>
              )}
            </>
          )}

          {selectedPages.series200?.pages?.gri204?.pages?.gri204_1 && (
            <>
              <PageBreak />
              <GRI204_1 hide={true} />
            </>
          )}
          {isAnySelected(selectedPages.series200?.pages?.gri205?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                205 : Anti-corruption 2016
              </p>
              {selectedPages.series200.pages.gri205.pages.gri205_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI205_1 hide={true} />
                </>
              )}
              {selectedPages.series200.pages.gri205.pages.gri205_2 && (
                <>
                  <PageBreak />
                  <GRI205_2 hide={true} downloadMode={true} />
                </>
              )}
              {selectedPages.series200.pages.gri205.pages.gri205_3 && (
                <>
                  <PageBreak />
                  <GRI205_3 hide={true} downloadMode={true} />
                </>
              )}
            </>
          )}
          {selectedPages.series200?.pages?.gri206?.pages?.gri206_1 && (
            <>
              <PageBreak />
              <GRI206_1 hide={true} />
            </>
          )}
          {isAnySelected(selectedPages.series200?.pages?.gri207?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                207 : Tax 2019
              </p>
              {selectedPages.series200.pages.gri207.pages.gri207_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI207_1 hide={true} />
                </>
              )}
              {selectedPages.series200.pages.gri207.pages.gri207_2 && (
                <>
                  <PageBreak />
                  <GRI207_2 hide={true} />
                </>
              )}
              {selectedPages.series200.pages.gri207.pages.gri207_3 && (
                <>
                  <PageBreak />
                  <GRI207_3 hide={true} />
                </>
              )}
              {selectedPages.series200.pages.gri207.pages.gri207_4 && (
                <>
                  <PageBreak />
                  <GRI207_4 hide={true} downloadMode={true} />
                </>
              )}
            </>
          )}
          {/* 300 Series Sections */}
          {isAnySelected(selectedPages.series300?.pages?.gri301?.pages) && (
            <>
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                301 : Material Used
              </p>
              {selectedPages.series300.pages.gri301.pages.gri301_1 && (
                <>
                  <PageBreak />
                  <GRI301_1 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri301.pages.gri301_2 && (
                <>
                  <PageBreak />
                  <GRI301_2 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri301.pages.gri301_3 && (
                <>
                  <PageBreak />
                  <GRI301_3 hide={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series300?.pages?.gri302?.pages) && (
            <>
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                302 : ENERGY
              </p>
              {selectedPages.series300.pages.gri302.pages.gri302_1 && (
                <>
                  <PageBreak />
                  <GRI302_1 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri302.pages.gri302_2 && (
                <>
                  <PageBreak />
                  <GRI302_2 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri302.pages.gri302_3 && (
                <>
                  <PageBreak />
                  <GRI302_3 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri302.pages.gri302_4 && (
                <>
                  <PageBreak />
                  <GRI302_4 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri302.pages.gri302_5 && (
                <>
                  <PageBreak />
                  <GRI302_5 hide={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series300?.pages?.gri303?.pages) && (
            <>
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                303 : Water & Effluents
              </p>
              {selectedPages.series300.pages.gri303.pages.gri303_1 && (
                <>
                  <PageBreak />
                  <GRI303_1 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri303.pages.gri303_2 && (
                <>
                  <PageBreak />
                  <GRI303_2 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri303.pages.gri303_3 && (
                <>
                  <PageBreak />
                  <GRI303_3 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri303.pages.gri303_4 && (
                <>
                  <PageBreak />
                  <GRI303_4 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri303.pages.gri303_5 && (
                <>
                  <PageBreak />
                  <GRI303_5 hide={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series300?.pages?.gri304?.pages) && (
            <>
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                304 : Biodiversity
              </p>
              {selectedPages.series300.pages.gri304.pages.gri304_1 && (
                <>
                  <PageBreak />
                  <GRI304_1 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri304.pages.gri304_2 && (
                <>
                  <PageBreak />
                  <GRI304_2 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri304.pages.gri304_3 && (
                <>
                  <PageBreak />
                  <GRI304_3 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri304.pages.gri304_4 && (
                <>
                  <PageBreak />
                  <GRI304_4 hide={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series300?.pages?.gri305?.pages) && (
            <>
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                305 : Emissions
              </p>
              {selectedPages.series300.pages.gri305.pages.gri305_1 && (
                <>
                  <PageBreak />
                  <GRI305_1 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri305.pages.gri305_2 && (
                <>
                  <PageBreak />
                  <GRI305_2 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri305.pages.gri305_3 && (
                <>
                  <PageBreak />
                  <GRI305_3 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri305.pages.gri305_4 && (
                <>
                  <PageBreak />
                  <GRI305_4 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri305.pages.gri305_5 && (
                <>
                  <PageBreak />
                  <GRI305_5 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri305.pages.gri305_6 && (
                <>
                  <PageBreak />
                  <GRI305_6 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri305.pages.gri305_7 && (
                <>
                  <PageBreak />
                  <GRI305_7 hide={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series300?.pages?.gri306?.pages) && (
            <>
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                306 : Waste
              </p>
              {selectedPages.series300.pages.gri306.pages.gri306_1 && (
                <>
                  <PageBreak />
                  <GRI306_1 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri306.pages.gri306_2 && (
                <>
                  <PageBreak />
                  <GRI306_2 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri306.pages.gri306_3 && (
                <>
                  <PageBreak />
                  <GRI306_3 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri306.pages.gri306_4 && (
                <>
                  <PageBreak />
                  <GRI306_4 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri306.pages.gri306_5 && (
                <>
                  <PageBreak />
                  <GRI306_5 hide={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series300?.pages?.gri308?.pages) && (
            <>
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                308 : Supplier Env
              </p>
              {selectedPages.series300.pages.gri308.pages.gri308_1 && (
                <>
                  <PageBreak />
                  <GRI308_1 hide={true} />
                </>
              )}
              {selectedPages.series300.pages.gri308.pages.gri308_2 && (
                <>
                  <PageBreak />
                  <GRI308_2 hide={true} />
                </>
              )}
            </>
          )}
          {/* 400 Series Sections */}
          {isAnySelected(selectedPages.series400?.pages?.gri401?.pages) && (
            <>
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                401 : Material Used
              </p>
              {selectedPages.series400.pages.gri401.pages.gri401_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI401_1 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri401.pages.gri401_2 && (
                <>
                  <PageBreak />
                  <GRI401_2 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri401.pages.gri401_3 && (
                <>
                  <PageBreak />
                  <GRI401_3 hide={true} />
                </>
              )}
            </>
          )}
          {selectedPages.series400?.pages?.gri402?.pages?.gri402 && (
            <>
              <PageBreak />
              <GRI402 hide={true} />
            </>
          )}
          {isAnySelected(selectedPages.series400?.pages?.gri403?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                403 : Occupational Health and Safety
              </p>
              {selectedPages.series400.pages.gri403.pages.gri403_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI403_1 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri403.pages.gri403_2 && (
                <>
                  <PageBreak />
                  <GRI403_2 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri403.pages.gri403_3 && (
                <>
                  <PageBreak />
                  <GRI403_3 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri403.pages.gri403_4 && (
                <>
                  <PageBreak />
                  <GRI403_4 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri403.pages.gri403_5 && (
                <>
                  <PageBreak />
                  <GRI403_5 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri403.pages.gri403_6 && (
                <>
                  <PageBreak />
                  <GRI403_6 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri403.pages.gri403_7 && (
                <>
                  <PageBreak />
                  <GRI403_7 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri403.pages.gri403_8 && (
                <>
                  <PageBreak />
                  <GRI403_8 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri403.pages.gri403_9 && (
                <>
                  <PageBreak />
                  <GRI403_9 hide={true} downloadMode={true} />
                </>
              )}
              {selectedPages.series400.pages.gri403.pages.gri403_10 && (
                <>
                  <PageBreak />
                  <GRI403_10 hide={true} downloadMode={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series400?.pages?.gri404?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                404 : Training and Education
              </p>
              {selectedPages.series400.pages.gri404.pages.gri404_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI404_1 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri404.pages.gri404_2 && (
                <>
                  <PageBreak />
                  <GRI404_2 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri404.pages.gri404_3 && (
                <>
                  <PageBreak />
                  <GRI404_3 hide={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series400?.pages?.gri405?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                405 : Diversity and Equal Opportunity
              </p>
              {selectedPages.series400.pages.gri405.pages.gri405_1 && (
                <>
                  <PageBreak />
                  <GRI405_1 hide={true} downloadMode={true} />
                </>
              )}
              {selectedPages.series400.pages.gri405.pages.gri405_2 && (
                <>
                  <PageBreak />
                  <GRI405_2 hide={true} />
                </>
              )}
            </>
          )}
          {selectedPages.series400?.pages?.gri406?.pages?.gri406 && (
            <>
              <PageBreak />
              <GRI406 hide={true} />
            </>
          )}
          {selectedPages.series400?.pages?.gri407?.pages?.gri407 && (
            <>
              <PageBreak />
              <GRI407 hide={true} />
            </>
          )}
          {selectedPages.series400?.pages?.gri408?.pages?.gri408 && (
            <>
              <PageBreak />
              <GRI408 hide={true} />
            </>
          )}
          {selectedPages.series400?.pages?.gri409?.pages?.gri409 && (
            <>
              <PageBreak />
              <GRI409 hide={true} />
            </>
          )}
          {selectedPages.series400?.pages?.gri410?.pages?.gri410 && (
            <>
              <PageBreak />
              <GRI410 hide={true} />
            </>
          )}
          {selectedPages.series400?.pages?.gri411?.pages?.gri411 && (
            <>
              <PageBreak />
              <GRI411 hide={true} />
            </>
          )}
          {isAnySelected(selectedPages.series400?.pages?.gri413?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                413 : Local Communities
              </p>
              {selectedPages.series400.pages.gri413.pages.gri413_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI413_1 hide={true} downloadMode={true} />
                </>
              )}
              {selectedPages.series400.pages.gri413.pages.gri413_2 && (
                <>
                  <PageBreak />
                  <GRI413_2 hide={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series400?.pages?.gri414?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                414 : Supplier Social Assessment
              </p>
              {selectedPages.series400.pages.gri414.pages.gri414_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI414_1 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri414.pages.gri414_2 && (
                <>
                  <PageBreak />
                  <GRI414_2 hide={true} />
                </>
              )}
            </>
          )}
          {selectedPages.series400?.pages?.gri415?.pages?.gri415 && (
            <>
              <PageBreak />
              <GRI415 hide={true} />
            </>
          )}
          {isAnySelected(selectedPages.series400?.pages?.gri416?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                416 : Customer Health & Safety
              </p>
              {selectedPages.series400.pages.gri416.pages.gri416_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI416_1 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri416.pages.gri416_2 && (
                <>
                  <PageBreak />
                  <GRI416_2 hide={true} />
                </>
              )}
            </>
          )}
          {isAnySelected(selectedPages.series400?.pages?.gri417?.pages) && (
            <>
              <PageBreak />
              <p
                className={styles.section_heading}
                style={{ marginBottom: "-1rem" }}
              >
                417 : Marketing & Labelling
              </p>
              {selectedPages.series400.pages.gri417.pages.gri417_1 && (
                <>
                  {/* <PageBreak /> */}
                  <GRI417_1 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri417.pages.gri417_2 && (
                <>
                  <PageBreak />
                  <GRI417_2 hide={true} />
                </>
              )}
              {selectedPages.series400.pages.gri417.pages.gri417_3 && (
                <>
                  <PageBreak />
                  <GRI417_3 hide={true} />
                </>
              )}
            </>
          )}
          {selectedPages.series400?.pages?.gri418?.pages?.gri418 && (
            <>
              <PageBreak />
              <GRI418 hide={true} />
            </>
          )}
        </Box>
      </div>
    </>
  );
};

export default GRIDownloadPuppeteer;
